// 格式化时间,接收的time是Date格式
export const timeFormat = (time, spe) => {
  spe = spe || '-'
  time = new Date(time)
  const year = time.getFullYear()
  let month = time.getMonth() + 1
  month = month < 10 ? '0' + month : month
  let day = time.getDate()
  day = day < 10 ? '0' + day : day
  return year + spe + month + spe + day
}
